import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ShopPage = ({ language, BACKEND_URL }) => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log('ShopPage mounted, BACKEND_URL:', BACKEND_URL);
    fetchProducts();
    fetchCategories();
  }, [selectedCategory]);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const url = selectedCategory === 'all' 
        ? `${BACKEND_URL}/shop/products`
        : `${BACKEND_URL}/shop/products?category=${selectedCategory}`;
      const response = await axios.get(url);
      setProducts(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
      setProducts([]); // Set empty array on error
    } finally {
      setLoading(false);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/shop/categories`);
      setCategories(response.data.categories);
    } catch (error) {
      console.error('Error fetching categories:', error);
      setCategories([]); // Set empty array on error
    }
  };



  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-orange-50 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-green-800 mb-4">
            {language === 'en' ? 'Religious Shop' : 'மத கடை'}
          </h1>
          <p className="text-gray-600">
            {language === 'en' 
              ? 'Authentic religious items for your spiritual needs'
              : 'உங்கள் ஆன்மீக தேவைகளுக்கான உண்மையான மத பொருட்கள்'}
          </p>
        </div>



        {/* Category Filter */}
        <div className="mb-8 flex flex-wrap gap-2 justify-center">
          <button
            onClick={() => setSelectedCategory('all')}
            className={`px-6 py-2 rounded-full ${
              selectedCategory === 'all'
                ? 'bg-green-600 text-white'
                : 'bg-white text-gray-700 hover:bg-green-100'
            } transition`}
          >
            {language === 'en' ? 'All Products' : 'அனைத்து பொருட்கள்'}
          </button>
          {categories.map(cat => (
            <button
              key={cat.value}
              onClick={() => setSelectedCategory(cat.value)}
              className={`px-6 py-2 rounded-full ${
                selectedCategory === cat.value
                  ? 'bg-green-600 text-white'
                  : 'bg-white text-gray-700 hover:bg-green-100'
              } transition`}
            >
              {language === 'en' ? cat.label_en : cat.label_ta}
            </button>
          ))}
        </div>

        {/* Products Grid */}
        {loading ? (
          <div className="text-center py-20">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-green-600 mx-auto"></div>
            <p className="mt-4 text-gray-600">
              {language === 'en' ? 'Loading products...' : 'பொருட்கள் ஏற்றப்படுகின்றன...'}
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {products.map(product => (
              <div
                key={product.id}
                className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition transform hover:-translate-y-1"
              >
                {/* Product Image */}
                <div className="h-48 bg-gray-200 overflow-hidden">
                  <img
                    src={product.image_url || 'https://via.placeholder.com/300x200?text=No+Image'}
                    alt={language === 'en' ? product.name : product.name_ta}
                    className="w-full h-full object-cover"
                  />
                </div>

                {/* Product Info */}
                <div className="p-4">
                  <h3 className="font-bold text-lg text-gray-800 mb-2 line-clamp-2">
                    {language === 'en' ? product.name : product.name_ta}
                  </h3>
                  <p className="text-sm text-gray-600 mb-3 line-clamp-2">
                    {language === 'en' ? product.description : product.description_ta}
                  </p>
                  
                  <div className="flex items-center justify-between">
                    <div>
                      <span className="text-2xl font-bold text-green-600">
                        ₹{product.price}
                      </span>
                    </div>
                    
                    <span
                      className="px-4 py-2 rounded-lg font-semibold bg-orange-100 text-orange-700 border border-orange-300"
                    >
                      {language === 'en' ? 'Coming Soon' : 'விரைவில் வருகிறது'}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {!loading && products.length === 0 && (
          <div className="text-center py-20">
            <p className="text-gray-600 text-lg">
              {language === 'en' 
                ? 'No products found in this category'
                : 'இந்த வகையில் பொருட்கள் எதுவும் இல்லை'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShopPage;
